import { Outlet } from 'react-router-dom'
import { AppShell } from '@mantine/core'
import { NavBar } from './NavBar'

export function AppLayout() {
  return (
    <AppShell
      header={{ height: 60 }}
      padding="md"
      styles={{
        header: {
          backgroundColor: 'var(--sat-nav-bg)',
          borderBottom: '1px solid var(--sat-nav-border)',
        },
        main: {
          backgroundColor: 'var(--sat-bg)',
        },
      }}
    >
      <AppShell.Header>
        <NavBar />
      </AppShell.Header>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  )
}
